/*============================================================================
Ajax the add to cart experience by revealing it in a side drawer
Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
(c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

This file includes:
- Basic Shopify Ajax API calls
- Ajax cart plugin

This requires:
- jQuery 1.8+
- handlebars.min.js (for cart template)
- modernizr.min.js
- snippet/ajax-cart-template.liquid

Customized version of Shopify's jQuery API
(c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
	if ((typeof attribute) !== 'string') {
		attribute += '';
		if (attribute === 'undefined') {
			attribute = '';
		}
	}
	return jQuery.trim(attribute);
};

/*============================================================================
API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
	// alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
	var $body = $(document.body),
	params = {
		type: 'POST',
		url: '/cart/update.js',
		data: 'note=' + attributeToString(note),
		dataType: 'json',
		beforeSend: function() {
			$body.trigger('beforeUpdateCartNote.ajaxCart', note);
		},
		success: function(cart) {
			if ((typeof callback) === 'function') {
				callback(cart);
			}
			else {
				ShopifyAPI.onCartUpdate(cart);
			}
			$body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
		},
		error: function(XMLHttpRequest, textStatus) {
			$body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
			ShopifyAPI.onError(XMLHttpRequest, textStatus);
		},
		complete: function(jqxhr, text) {
			$body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
		}
	};
	jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
	var data = eval('(' + XMLHttpRequest.responseText + ')');
	if (!!data.message) {
		alert(data.message + '(' + data.status  + '): ' + data.description);
	}
};

/*============================================================================
POST to cart/add.js returns the JSON of the cart
- Allow use of form element instead of just id
- Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
		
	var $body = $(document.body),
	params = {
		type: 'POST',
		url: '/cart/add.js',
		data: jQuery(form).serialize(),
		dataType: 'json',
		beforeSend: function(jqxhr, settings) {
			$body.trigger('beforeAddItem.ajaxCart', form);
		},
		success: function(line_item) {
			if ((typeof callback) === 'function') {
				callback(line_item, form);
			}
			else {
				ShopifyAPI.onItemAdded(line_item, form);
			}
			$body.trigger('afterAddItem.ajaxCart', [line_item, form]);
		},
		error: function(XMLHttpRequest, textStatus) {
			if ((typeof errorCallback) === 'function') {
				errorCallback(XMLHttpRequest, textStatus, form);
			}
			else {
				ShopifyAPI.onError(XMLHttpRequest, textStatus, form);
			}
			$body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus, form]);
		},
		complete: function(jqxhr, text) {
			$body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
		}
	};
	jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback, product) {
	$(document.body).trigger('beforeGetCart.ajaxCart');
	jQuery.getJSON('/cart.js', function (cart, textStatus) {
		if ((typeof callback) === 'function') {
			callback(cart, product);
		}
		else {
			ShopifyAPI.onCartUpdate(cart, product);
		}
		$(document.body).trigger('afterGetCart.ajaxCart', cart);
	});
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
	var $body = $(document.body),
	params = {
		type: 'POST',
		url: '/cart/change.js',
		data: 'quantity=' + quantity + '&line=' + line,
		dataType: 'json',
		beforeSend: function() {
			$body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
		},
		success: function(cart) {
			if ((typeof callback) === 'function') {
				callback(cart);
			}
			else {
				ShopifyAPI.onCartUpdate(cart);
			}
			$body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
		},
		error: function(XMLHttpRequest, textStatus) {
			$body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
			ShopifyAPI.onError(XMLHttpRequest, textStatus);
		},
		complete: function(jqxhr, text) {
			$body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
		}
	};
	jQuery.ajax(params);
};

/*============================================================================
Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {
	
	'use strict';

	// Public functions
	var init, loadCart;

	// Private general variables
	var settings, isUpdating, $body;

	// maz
	// Private plugin variables
	var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $cartOverlay;

	// maz
	// Private functions
	var formOverride, itemAddedCallback, 
	itemErrorCallback, cartUpdateCallback, buildCart, 
	cartCallback, adjustCart, adjustCartCallback, 
	createQtySelectors, qtySelectors, validateQty, 
	animate, showRandomTitle, closeCart;
	/*============================================================================
	Initialise the plugin and define global options
	==============================================================================*/
	init = function (options) {

		// Default settings
		settings = {
			formSelector       : 'form[action^="/cart/add"]',
			cartContainer      : '#CartContainer',
			addToCartSelector  : 'input[type="submit"]',
			cartCountSelector  : null,
			cartCostSelector   : null,
			moneyFormat        : '${{amount}}',
			disableAjaxCart    : false,
			enableQtySelectors : false
		};


		// Override defaults with arguments
		$.extend(settings, options);

		// Select DOM elements
		$formContainer     = $(settings.formSelector);
		$cartContainer     = $(settings.cartContainer);
		$addToCart         = $formContainer.find(settings.addToCartSelector);
		$cartCountSelector = $(settings.cartCountSelector);
		$cartCostSelector  = $(settings.cartCostSelector);
		$cartOverlay 	   = $('.js-cartdrawer-overlay');

		// General Selectors
		$body = $(document.body);

		// Track cart activity status
		isUpdating = false;

		// Setup ajax quantity selectors on the any template if enableQtySelectors is true
		
		if (settings.enableQtySelectors) {
			qtySelectors();
		}

		// Take over the add to cart form submit action if ajax enabled
		formOverride();

		// Run this function in case we're using the quantity selector outside of the cart
		//adjustCart();
    
		// listen the cart closing for refresh of the animated elements
		$('.js-drawer-close').on('click', closeCart);
	};

	loadCart = function () {
		$body.addClass('drawer--is-loading');
		ShopifyAPI.getCart(cartUpdateCallback);
	};

	formOverride = function () {
	  
		//Change action from below to make it dynamic
		//$formContainer.on('submit', function(evt) {
			$('body').on('click', '.AddToCart', function(evt) {  
				evt.preventDefault();
				var form = $(this).closest('.AddToCartForm')

				// Add class to be styled if desired
				$addToCart.removeClass('is-added').addClass('is-adding');

				// Remove any previous quantity errors
				$('.qty-error').remove();
	  	  
				ShopifyAPI.addItemFromForm(form, itemAddedCallback, itemErrorCallback);
			});
		};

		itemAddedCallback = function (product) {
			//alert(bundleCode);
			//If we have a bundle code redirect straight to the cart to determine the discount code
		  
			if (typeof bundleCode === 'undefined') {
				$addToCart.removeClass('is-adding').addClass('is-added');
				ShopifyAPI.getCart(cartUpdateCallback, product);
			} else {
				window.location.replace("/cart");
			}
		};

		itemErrorCallback = function (XMLHttpRequest, textStatus, form) {
			var data = eval('(' + XMLHttpRequest.responseText + ')');
			$addToCart.removeClass('is-adding is-added');

			if (!!data.message) {
				if (data.status == 422) {
					form.after('<div class="errors qty-error">'+ data.description +'</div>')
				}
			}
		};

		cartUpdateCallback = function (cart, product) {
			// Update quantity and price
			
			if ( cart.total_price > 0 ) {
				update_mini_cart(cart)
				buildCart(cart, product);
				update_cart_count(cart)
			} 
		};

		/*
		animate = function(showBasketAnimation = true, img) {
	  	  
			var $cartImage = $('.js-cart-image');
			var $basket = $('.js-drawer-basket');
			var $title = $('.js-ajax-cart-random-title.visible');
			var delay = 0.2;
			var ease = 'power4.easeinout';
			var $productText = $('.js-drawer-details');
    	
			if(showBasketAnimation === false) {
				$('.drawer__basketimg').remove(); 
			}
    
			$cartImage.attr('src', img); 
    
    
			// restart values
			gsap.set($title, {
				opacity: 0,
				y: 40
			});

			gsap.set($basket, {
				opacity: 0,
				y: 40
			});

			gsap.set($productText, {
				opacity: 0,
				y: 40
			});
    
			gsap.set($cartImage, {
				opacity: 0,
				y: showBasketAnimation ? -60 : 60,
				scale: 0.9
			});
    
			// animate title
			gsap.to($title, {
				duration: 0.5,
				delay: delay,
				opacity: 1,
				y: 0,
				ease: ease
			});
    
			delay += 0.2;
    
			// animate basket
			gsap.to($basket, {
				duration: 0.5,
				delay: delay,
				opacity: 1,
				y: 0,
				ease: ease
			});
			delay += 0.2;
    
			// animate texts
			gsap.to($productText, {
				duration: 0.5,
				delay: delay,
				opacity: 1,
				y: 0,
				ease: ease,
				stagger: 0.1
			});
			delay += 0.2;
    
			if (showBasketAnimation != false) {
				// animate thumb
				gsap.to($cartImage, {
					duration: 0.25,
					delay: delay,
					opacity: 1,
					ease: ease
				});
    
				gsap.to($cartImage, {
					duration: 0.5,
					delay: delay,
					scale: 1,
					ease: ease
				});
    
				gsap.to($cartImage, {
					duration: 0.5,
					delay: delay,
					y: showBasketAnimation ? 0 : 60,
					ease: 'bounce.out'
				});
			} else {
				$('.drawer__basketimg--product').css('opacity', '1').css('transform', 'initial').css('top', '0').css('position', 'initial')
				$('.drawer__basket').css('height', 'auto')
				$('.drawer__msg-container').css('margin-bottom', '20px')		
			}
		};
  
		showRandomTitle = function() {
			var items = $('.js-ajax-cart-random-title'); 
			var selectedItem = items[Math.floor(Math.random() * items.length)]
    
			$(selectedItem).addClass('visible');
		}*/
  
		buildCart = function (cart, product) {
			//console.log(cart)
			//console.log(product)
	  
			var free_shipping_available = true
			var contains_gift_card = false
  	
			$(cart.items).each(function(i, item) {
				if ( item.product_type == 'Rugs' ) {
					free_shipping_available = false
				}
			});  
	  
			// Start with a fresh cart div
			$cartContainer.empty();
	
			// Show empty cart
			if (cart.item_count === 0) {
				$cartContainer.append('<p>Your cart is currently empty.</p>'); 
				cartCallback(cart);
				return;
			} 
	
			update_mini_cart(cart);
			update_cart_drawer(cart);
			update_cart_count(cart);
			
			cartCallback(cart);
			
	
			/*
			if (typeof product !== 'undefined') {
				// Handlebars.js cart layout
				
				var
					items = [],
					item = {},
					data = {},
					source = $("#CartTemplate").html(),
					template = Handlebars.compile(source),
					featured_img = product.image;
				
				jQuery.getJSON('/products/'+product.handle+'.js', function(product) {
					//Need to run an ajax request to get the last product image
								
					if ( product.type != 'Gift Card' ) {
						//Get last image
						var images = product.images
						featured_img = images.slice(-1)[0]
					}
					
				
					// Create item's data object and add to 'items' array
					item = {
						key: product.key,
						line: 1, // Shopify uses a 1+ index in the API
						url: product.url,
						img: featured_img,
						name: product.title,
						variation: product.variant_title,
						properties: product.properties,
						itemAdd: product.quantity + 1,
						itemMinus: product.quantity - 1,
						itemQty: product.quantity,
						price: Shopify.formatMoney(product.price, settings.moneyFormat),
						vendor: product.vendor,
						linePrice: Shopify.formatMoney(product.line_price, settings.moneyFormat),
						originalLinePrice: Shopify.formatMoney(product.original_line_price, settings.moneyFormat),
						discounts: product.discounts,
						discountsApplied: product.line_price === product.original_line_price ? false : true
					};
		
					items.push(item);
    
					data = {
						items: items,
						note: cart.note,
						totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
						totalCartDiscount: "You're saving" + Shopify.formatMoney(cart.total_discount),
						totalCartDiscountApplied: cart.total_discount === 0 ? false : true
					}
    
					$cartContainer.append(template(data));
    
					showRandomTitle();

					var showBasketAnimation = true;
					var hideBasketAnimationVendorsList = hideBasketAnimationVendorsString.split(',');
					var productVendor = product.vendor

					if(productVendor && hideBasketAnimationVendorsList.length) {
					    var vendors = hideBasketAnimationVendorsList.map(function name(vendor) {
					        return vendor.toLowerCase().trim();
					    });

					    if(vendors.includes(productVendor.toLowerCase().trim())) {
					        showBasketAnimation = false;
					    }
					}

					animate(showBasketAnimation, featured_img);

					cartCallback(cart);
    
					var freeShippingValue = free_shipping * 100;

					if (free_shipping_available == true) {		 		
						if (freeShippingValue > 0) {
							var cartDifference = freeShippingValue - cart.total_price;
							if (cartDifference > 0) {
								$(".js-drawer-free-shipping").html("You're just <b>" + Shopify.formatMoney(cartDifference, settings.moneyFormat) + "</b> away from free shipping!").show();
							} else {
								$(".js-drawer-free-shipping").html('You qualify for free shipping!').show();
	
							}
						} else {
							$(".js-drawer-free-shipping").hide();
						}
					} else {
						$(".js-drawer-free-shipping").hide();
					}
				
					if ( gifting_enabled == 'true') {
						if ( contains_gift_card == false ) {
							$('#CartContainer .cart-gifting').css('display','flex');
						} 
					}
				
					if ( spend_save_promo == 'true' ) {
						let
							promo_diff = '',
							reward = '',
							reward_goal = '',
							reward_code = '',
							cart_total = 0;
						
						$(cart.items).each(function(i, line) {
							//console.log( line )
							jQuery.getJSON('/products/'+line.handle+'.js', function(product) {
								//console.log(product)
								if ( product.tags.indexOf("excl:spend&save") === -1) {
									cart_total = cart_total + line.line_price
								}
								update_spend_save(cart_total);
							});
						});
					
						function update_spend_save(cart_total){
							//console.log( cart_total )
						
							if ( store_location == 'uk' ) {
								if ( cart_total  < 20000 ) {
									promo_diff = 20000 - cart_total ;
									reward_goal = 3000;
								} else if ( cart_total  < 30000 ) {
									promo_diff = 30000 - cart_total ;
									reward = 3000;
									reward_goal = 6000;
								} else if ( cart_total  < 40000 ) {
									promo_diff = 40000 - cart_total ;
									reward = 6000;
									reward_goal = 12000;
								} else {
									promo_diff = ''
									reward = 12000;
								}
							} else if ( store_location == 'eu' ) {
								if ( cart_total  < 25000 ) {
									promo_diff = 25000 - cart_total ;
									reward_goal = 4000;
								} else if ( cart_total  < 35000 ) {
									promo_diff = 35000 - cart_total ;
									reward = 4000;
									reward_goal = 7000;
								} else if ( cart_total  < 45000 ) {
									promo_diff = 45000 - cart_total ;
									reward = 7000;
									reward_goal = 13500;
								} else {
									promo_diff = ''
									reward = 13500;
								}
							} else if ( store_location == 'us' ) {
								if ( cart_total  < 30000 ) {
									promo_diff = 30000 - cart_total ;
									reward_goal = 4500;
								} else if ( cart_total  < 40000 ) {
									promo_diff = 40000 - cart_total ;
									reward = 4500;
									reward_goal = 8000;
								} else if ( cart_total  < 50000 ) {
									promo_diff = 50000 - cart_total ;
									reward = 8000;
									reward_goal = 15000;
								} else {
									promo_diff = ''
									reward = 15000;
								}
							} else {
								if ( cart_total  < 30000 ) {
									promo_diff = 30000 - cart_total ;
									reward_goal = 4500;
								} else if ( cart_total  < 40000 ) {
									promo_diff = 40000 - cart_total ;
									reward = 4500;
									reward_goal = 8000;
								} else if ( cart_total  < 50000 ) {
									promo_diff = 50000 - cart_total ;
									reward = 8000;
									reward_goal = 15000;
								} else {
									promo_diff = ''
									reward = 15000;
								}
							}
							$('#cart-reward').html( Shopify.formatMoney(reward) );
							$('#cart-reward-goal').html( Shopify.formatMoney(reward_goal) );
							$('#cart-reward-diff').html( Shopify.formatMoney(promo_diff) );
			
							if ( reward == '' ) {
								$('.js-drawer-cart-rewards').hide()
							} else {
								$('.js-drawer-cart-rewards').show()
							} 

							//console.log('promo diff'+promo_diff )
							if ( promo_diff == '' ) {
								$('.js-drawer-cart-reward-goal').hide()
							} else {
								$('.js-drawer-cart-reward-goal').show()
							}
						}
					}
				}).done(function(data) {
    	
					const url = '/recommendations/products?section_id=related-products&product_id='+product.product_id+'&limit=3';
			  
					fetch(url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						let recommendations = html.querySelector('#related-products');
						recommendations = recommendations.children;
					
						if ( recommendations.length != 0 ) {
							$('#cart-upsell .grid').html( recommendations );
							$('#cart-upsell').fadeIn()
						}
					
						//Custom cart upsell 
						if ( cart_upsell_1 == 'true' ) {
							if ( upsell_trigger_1.indexOf(product.handle) !== -1 ) {
								$('#cart-upsell').hide()
								$('#cart-upsell-custom-1').slideDown()
							}
						}
						if ( cart_upsell_2 == 'true' ) {
							if ( upsell_trigger_2.indexOf(product.handle) !== -1 ) {
								$('#cart-upsell').hide()
								$('#cart-upsell-custom-2').slideDown()
							}
						}
						if ( cart_upsell_3 == 'true' ) {
							if ( upsell_trigger_3.indexOf(product.handle) !== -1 ) {
								$('#cart-upsell').hide()
								$('#cart-upsell-custom-3').slideDown()
							}
						}
						if ( cart_upsell_4 == 'true' ) {
							if ( upsell_trigger_4.indexOf(product.handle) !== -1 ) {
								$('#cart-upsell').hide()
								$('#cart-upsell-custom-4').slideDown()
							}
						}	
						
					}) 
					.catch(e => {
						console.error(e);
					});
				
					gwp();
				});	
			}
			*/
	
		};

		cartCallback = function(cart) {
			$body.removeClass('drawer--is-loading');
			$body.trigger('afterCartLoad.ajaxCart', cart);

			if (window.Shopify && Shopify.StorefrontExpressButtons) {
				Shopify.StorefrontExpressButtons.initialize();
			}
		};

		/*
		adjustCart = function () {
			// Delegate all events because elements reload with the cart

			// Add or remove from the quantity
			$body.on('click', '.ajaxcart__qty-adjust', function() {
				if (isUpdating) {
					return;
				}

				var $el = $(this),
				line = $el.data('line'),
				$qtySelector = $el.siblings('.ajaxcart__qty-num'),
				qty = parseInt($qtySelector.val().replace(/\D/g, ''));

				var qty = validateQty(qty);

				// Add or subtract from the current quantity
				if ($el.hasClass('ajaxcart__qty--plus')) {
					qty += 1;
				} else {
					qty -= 1;
					if (qty <= 0) qty = 0;
				}

				// If it has a data-line, update the cart.
				// Otherwise, just update the input's number
				if (line) {
					updateQuantity(line, qty);
				} else {
					$qtySelector.val(qty);
				}
			});

			// Update quantity based on input on change
			$body.on('change', '.ajaxcart__qty-num', function() {
				if (isUpdating) {
					return;
				}

				var $el = $(this),
				line = $el.data('line'),
				qty = parseInt($el.val().replace(/\D/g, ''));

				var qty = validateQty(qty);

				// If it has a data-line, update the cart
				if (line) {
					updateQuantity(line, qty);
				}
			});

			// Prevent cart from being submitted while quantities are changing
			$body.on('submit', 'form.ajaxcart', function(evt) {
				if (isUpdating) {
					evt.preventDefault();
				}
			});

			// Highlight the text when focused
			$body.on('focus', '.ajaxcart__qty-adjust', function() {
				var $el = $(this);
				setTimeout(function() {
					$el.select();
				}, 50);
			});

			function updateQuantity(line, qty) {
				isUpdating = true;

				// Add activity classes when changing cart quantities
				var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

				if (qty === 0) {
					$row.parent().addClass('is-removed');
				}

				// Slight delay to make sure removed animation is done
				setTimeout(function() {
					ShopifyAPI.changeItem(line, qty, adjustCartCallback);
				}, 250);
			}

			// Save note anytime it's changed
			$body.on('change', 'textarea[name="note"]', function() {
				var newNote = $(this).val();

				// Update the cart note in case they don't click update/checkout
				ShopifyAPI.updateCartNote(newNote, function(cart) {});
			});
		};

		adjustCartCallback = function (cart) {
			// Update quantity and price
			update_mini_cart(cart)
			update_cart_count(cart)
			
			// Reprint cart on short timeout so you don't see the content being removed
			setTimeout(function() {
				isUpdating = false;
				ShopifyAPI.getCart(buildCart);								
			}, 150)
		};

		createQtySelectors = function() {
			// If there is a normal quantity number field in the ajax cart, replace it with our version
			if ($('input[type="number"]', $cartContainer).length) {
				$('input[type="number"]', $cartContainer).each(function() {
					var $el = $(this),
					currentQty = $el.val();

					var itemAdd = currentQty + 1,
					itemMinus = currentQty - 1,
					itemQty = currentQty;

					var source   = $("#AjaxQty").html(),
					template = Handlebars.compile(source),
					data = {
						key: $el.data('id'),
						itemQty: itemQty,
						itemAdd: itemAdd,
						itemMinus: itemMinus
					};

					// Append new quantity selector then remove original
					$el.after(template(data)).remove();
				});
			}
		};

		qtySelectors = function() {
			// Change number inputs to JS ones, similar to ajax cart but without API integration.
			// Make sure to add the existing name and id to the new input element
			var numInputs = $('input[type="number"]');

			if (numInputs.length) {
				numInputs.each(function() {
					var $el = $(this),
					currentQty = $el.val(),
					inputName = $el.attr('name'),
					inputId = $el.attr('id');

					var itemAdd = currentQty + 1,
					itemMinus = currentQty - 1,
					itemQty = currentQty;

					var source   = $("#JsQty").html(),
					template = Handlebars.compile(source),
					data = {
						key: $el.data('id'),
						itemQty: itemQty,
						itemAdd: itemAdd,
						itemMinus: itemMinus,
						inputName: inputName,
						inputId: inputId
					};

					// Append new quantity selector then remove original
					$el.after(template(data)).remove();
				});

				// Setup listeners to add/subtract from the input
				$('.js-qty__adjust').on('click', function() {
					var $el = $(this),
					id = $el.data('id'),
					$qtySelector = $el.siblings('.js-qty__num'),
					qty = parseInt($qtySelector.val().replace(/\D/g, ''));

					var qty = validateQty(qty);

					// Add or subtract from the current quantity
					if ($el.hasClass('js-qty__adjust--plus')) {
						qty += 1;
					} else {
						qty -= 1;
						if (qty <= 1) qty = 1;
					}

					// Update the input's number
					$qtySelector.val(qty);
				});
			}
		};
 
		validateQty = function (qty) {
			if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
				// We have a valid number!
			} else {
				// Not a number. Default to 1.
				qty = 1;
			}
			return qty;
		}; */

		module = {
			init: init,
			load: loadCart
		};

		return module;


	}(ajaxCart || {}, jQuery));
